import { schemaConsorsNote } from 'cpool-schemas';
import { z } from 'zod';

export const schemaGetConsorsNotesByLeadId = z.object({
    hasNewConsorsNotes: z.boolean(),
    notes: z.array(schemaConsorsNote),
});

export type SchemaGetConsorsNotesByLeadId = z.infer<typeof schemaGetConsorsNotesByLeadId>;
